import { BarItem } from "../../../../domain/document/items";
import { ValueRange } from "../../../../domain/system";
import { IBarItemBean, BeanTypes, } from "../beans/items";
import { HtmlColorCodeTranslator } from "./HtmlColorCodeTranslator";
import { AbstractSourceEditableItemTranslator } from "./AbstractSourceEditableItemTranslator";

export class BarItemTranslator extends AbstractSourceEditableItemTranslator<BarItem, IBarItemBean> {
  protected createItem(source: IBarItemBean): BarItem {
    const result = new BarItem();
    result.range = new ValueRange(source.minValue, source.maxValue);
    result.stepCount = source.stepCount;
    result.direction = source.direction;
    result.paintStyle = HtmlColorCodeTranslator.toPaintStyleFill(source.backColor);
    result.paintStyleOnEditing = source.isDisplayBackColorSpecified
      ? HtmlColorCodeTranslator.toPaintStyleFill(source.displayBackColor)
      : null;
    result.shouldDrawNarrow = source.shouldDrawNarrow;
    return result;
  }

  protected createBean(source: BarItem): IBarItemBean {
    const result = {
      type: BeanTypes.Bar,
      minValue: source.range.min,
      maxValue: source.range.max,
      stepCount: source.stepCount,
      direction: source.direction,
      backColor: HtmlColorCodeTranslator.fromPaintStyle(source.paintStyle),
      isDisplayBackColorSpecified: !!source.paintStyleOnEditing,
      displayBackColor: HtmlColorCodeTranslator.fromPaintStyle(source.paintStyleOnEditing),
      shouldDrawNarrow: source.shouldDrawNarrow,
    };
    return result as IBarItemBean;
  }
}
